const facilitiesRoute = createApiRoute(ApiModule.AUTH, ApiDataModel.FACILITIES)

export const apiFacility = {
	fetchFacilities: async (): Promise<IFacilityModel[]> => {
		const { data } = await apiCommon<IFacility[]>(facilitiesRoute, { method: 'GET' })

		return data ? data.map(d => Facility(d)) : []
	},
}
